module.exports = __webpack_public_path__ + "img/loading.55d9d80d.svg";